// extracted by mini-css-extract-plugin
export var hero = "garment-module--hero--30Tts";
export var herob = "garment-module--herob--32nNg";
export var herosection = "garment-module--herosection--1BD89";
export var categories = "garment-module--categories--xxcHd";
export var heroheader = "garment-module--heroheader--2MV-Q";
export var herosectionb = "garment-module--herosectionb--vd986";
export var pmenuactive = "garment-module--pmenuactive--1rpSO";
export var pmenu = "garment-module--pmenu--3FGs8";